'use client';

import { useState, useEffect } from 'react';
import { getCurrentZone } from '@/data/zones';

export default function ZoneAwarePlantZones({
  plantZones,
  zoneMin,
  zoneMax,
}: {
  plantZones: number[];
  zoneMin: number;
  zoneMax: number;
}) {
  const [userZone, setUserZone] = useState<number | null>(null);

  useEffect(() => {
    setUserZone(getCurrentZone());
  }, []);

  const userZoneGrows = userZone !== null ? plantZones.includes(userZone) : null;

  return (
    <>
      <div className="flex gap-2 flex-wrap">
        {Array.from({ length: 13 }, (_, i) => i + 1).map(zone => {
          const active     = plantZones.includes(zone);
          const isUserZone = userZone === zone;
          return (
            <div key={zone} className="relative flex flex-col items-center">
              <div
                className={[
                  'w-9 h-9 rounded-full flex items-center justify-center',
                  'text-[13px] font-body font-bold select-none',
                  active ? 'bg-deep-green text-white' : 'bg-[#E5E5E5] text-[#999]',
                  isUserZone ? 'ring-2 ring-offset-1 ring-[#2D5016]' : '',
                ].join(' ')}
              >
                {zone}
              </div>
              {isUserZone && (
                <span className="absolute -bottom-5 left-1/2 -translate-x-1/2 whitespace-nowrap
                                 font-body text-[10px] font-semibold text-sage">
                  You
                </span>
              )}
            </div>
          );
        })}
      </div>

      <p className={`font-body text-[14px] text-sage ${userZone ? 'mt-6' : ''}`}>
        Thrives in USDA Zones {zoneMin} - {zoneMax}
      </p>

      {userZoneGrows === true && (
        <div className="bg-[#E8F0E4] rounded-lg px-4 py-3">
          <p className="font-body text-[13px] font-semibold text-[#2D5016]">
 ✓ This plant thrives in your zone (Zone {userZone})
          </p>
        </div>
      )}

      {userZoneGrows === false && (
        <div className="bg-[#F5F0E8] rounded-lg px-4 py-3">
          <p className="font-body text-[13px] font-semibold text-[#8B6F47]">
            Zone {userZone}: this plant may be challenging in your area
          </p>
          <p className="font-body text-[12px] text-sage mt-1 leading-relaxed">
            Consider season-extension techniques like cold frames, row covers, or growing
            in a greenhouse to give this plant the conditions it needs.
          </p>
        </div>
      )}
    </>
  );
}
